import React from 'react';

interface CardProps {
  title?: string;
  footer?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const Card: React.FC<CardProps> = ({ title, footer, children, className }) => {
  return (
    <div className={`card ${className || ''}`}>
      {title && (
        <div className="mb-4 pb-2 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
        </div>
      )}
      
      <div>{children}</div>
      
      {footer && (
        <div className="mt-4 pt-3 border-t border-gray-200">
          {footer}
        </div>
      )}
    </div>
  );
};

export default Card; 